var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('banner-component'),_c('brands-component',{attrs:{"id":"brands"}}),(_vm.lang === 'en')?_c('news-component',{attrs:{"observer":_vm.observer,"load-news":_vm.loadNews}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }